import React from "react";
import { navigate, graphql } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";
import MapGrid from "../components/mapgrid";
import Map from "../components/map/map";
import AutoWidth from "../components/AutoWidth/AutoWidth";

import sectors from "../geojson/sectors.json";
import sectorNames from "../geojson/sector_names.json";
import points from "../geojson/points.json";
require(`typeface-open-sans`);

const layers = [
  {
    id: `points-show`,
    source: `points`,
    type: `circle`,
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [
          [12, 2],
          [22, 180]
        ]
      },
      "circle-color": `#777`
    }
  },
  {
    id: `sector-fill`,
    source: `sectors`,
    type: `fill`,
    paint: {
      "fill-color": `#888888`,
      "fill-opacity": [
        `case`,
        [`boolean`, [`feature-state`, `hover`], false],
        0.8,
        0.5
      ]
    }
  },
  {
    id: `sector-line`,
    source: `sectors`,
    type: `line`,
    paint: {
      "line-color": `#333`,
      "line-opacity": 0.6,
      "line-width": 2
    }
  },
  {
    id: `sector-name`,
    source: `names`,
    type: `symbol`,
    layout: {
      "symbol-placement": `point`,
      "text-field": [`get`, `Name`],
      "text-size": [
        `interpolate`,
        [`linear`],
        [`zoom`],
        // zoom is 12 (or less) -> size will be 12px
        12,
        12,
        // zoom is 10 (or greater) -> circle radius will be 5px
        20,
        50
      ],
      "text-justify": `center`,
      "text-anchor": `center`,
      "text-allow-overlap": false,
      "text-ignore-placement": true
    },
    paint: {
      "text-halo-color": `#ffffff`,
      "text-halo-width": 2
    }
  }
];

const sources = {
  points: { type: `geojson`, data: points },
  sectors: { type: `geojson`, data: sectors },
  names: { type: `geojson`, data: sectorNames }
};

function handleMapClick(event) {
  if (event.features && event.features.length > 0) {
    const sector = event.features[0].properties.Name;
    navigate(`/${sector}`);
  }
}

function IndexPage({ data }) {
  return (
    <Layout>
      <SEO keywords={[`seattle`, `map`, `tour`]} title="Seattle In Context" />
      <h1 className="text-5xl text-center p-3">Seattle In Context</h1>
      <p className="markdown">
        Block-by-block details of the people, places and things that make
        Seattle great. Click an area in the map below.
      </p>
      <Map layers={layers} onClick={handleMapClick} sources={sources} />
      <h2 className="text-4xl text-center p-3">Areas</h2>
      <AutoWidth>
        <MapGrid pages={data.allMarkdownRemark.edges} />
      </AutoWidth>
    </Layout>
  );
}
export default IndexPage;

export const query = graphql`
  query {
    allMarkdownRemark(sort: { order: ASC, fields: [frontmatter___title] }) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            path
            north
            south
            east
            west
          }
        }
      }
    }
  }
`;
